document.addEventListener("turbolinks:load", function () {
    var clipboard  = new ClipboardJS('.copy-to-clipboard');
    clipboard.on('success', function(e) {
      $(e.trigger).addClass('copied')
      e.clearSelection();
    });
})